var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "625 406 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 678"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635 406h13a10 10 0 0 1 10 10v13a10 10 0 0 1-10 10h-13a10 10 0 0 1-10-10v-13a10 10 0 0 1 10-10z",
    fillRule: "evenodd",
    "data-name": "Rectangle 935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635.077 425.463-.874 4.334 4.334-.874 10.26-10.26-3.46-3.459-10.26 10.26Zm.682 2.78.439-2.18 1.739 1.74-2.178.44Zm11.317-9.58-8.28 8.28-1.739-1.74 8.28-8.28 1.74 1.74Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "iconmonstr-pencil-11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.114ab5905c031ad48269d9bf88f6108a.svg";
export { ForwardRef as ReactComponent };